// Example:
// <div data-fitvids> ... video ... </div>

import '9.vendors/jquery.fitvids.js';

export default class FitVids {
  constructor($context) {
    $context.find('[data-fitvids]').fitVids({
      customSelector: 'iframe[src*="dailymotion.com"]'
    });
  }
}



// WEBPACK FOOTER //
// ./4.plugins/FitVids/FitVids.js